'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Locales = function () {
  function Locales() {
    var translations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Locales);

    this.langs = {
      en: {
        name: 'English',
        translations: translations.en,
        reactIntlCode: 'en'
      },
      zh: {
        name: 'Chinese (Hong Kong)',
        translations: translations.zh,
        reactIntlCode: 'zh-Hant-HK'
      }
    };
  }

  _createClass(Locales, [{
    key: 'isLangExists',
    value: function isLangExists(lang) {
      var langsUsed = Object.keys(this.langs);
      return langsUsed.indexOf(lang) !== -1;
    }
  }, {
    key: 'getTranslations',
    value: function getTranslations(lang) {
      return this.langs[lang].translations;
    }
  }, {
    key: 'getReactIntlCode',
    value: function getReactIntlCode(lang) {
      return this.langs[lang].reactIntlCode;
    }
  }]);

  return Locales;
}();

exports.default = Locales;